let default_page_name = "首页";

export default{
    page_name: default_page_name
}


// WEBPACK FOOTER //
// ./src/store/state.js